<template>
  <div class="pop">
    <div class="back">
      <img :src="back" alt="" @click="handleClose">
      <div class="title">{{ $t('lang.upi.how') }}</div>
    </div>
    <div class="content">
      <div class="subTitle">{{ $t('lang.upi.picture') }}</div>
      <div class="helpPic"><img :src="upi"/></div>
      <div class="desc">{{ $t('lang.upi.swipe') }}</div>
      <div class="subTitle" v-if="0">{{ $t('lang.upi.video') }}</div>
      <div class="video" v-if="0" @click="videoPlay">
        <img class="preview"
             src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/6wmwclfy090o2nvf8zophvba5yz8rgfj1.jpg"/>
        <img class="play" :src="play"/>
      </div>
    </div>
    <div class="videoPreview" v-if="videoUrl&&previewShow">
      <div class="videoBox">
        <video v-if="videoUrl" controls>
          <source :src="videoUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="close">
        <img :src="close" @click="closePreview"/>
      </div>
    </div>
  </div>
</template>

<script>
import back from '@/assets/images/common/back.svg'
import play from '@/assets/images/account/play.png'
import upi from '@/assets/images/account/UPI.png'
import close from '@/assets/images/sportsBetting/close.svg'

export default {
  name: 'upiHelpPop',
  props: ['handleClose'],
  data () {
    return {
      close,
      previewShow: false,
      videoUrl: 'https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/webbanner/help.mp4',
      upi,
      play,
      back
    }
  },
  mounted () {
  },
  methods: {
    videoPlay () {
      this.previewShow = true
    },
    closePreview () {
      this.previewShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.pop {
  position: fixed;
  top: 56px;
  width: 100vw;
  height: calc(100vh - 56px);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2;
  background-color: #161616;
  padding-bottom: calc(5vw + 70px);

  .back {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 8px;
    padding: 0 16px;

    .title {
      font-size: 18px;
      line-height: 30px;
      color: #F6D9AA;
      font-weight: bold;
      margin-left: 15px;
    }

    img {
      width: 30px;
      height: 30px;
    }
  }

  .content {
    .subTitle {
      margin: 3vw 0 2.7vw 6.666vw;
      font-size: 4.722vw;
      font-weight: 400;
      text-align: left;
      color: #F6D9AA;
      //display: none;
    }

    .helpPic {
      width: 100vw;
      height: 106.944vw;
      overflow-y: hidden;
      overflow-x: auto;

      img {
        height: 106.944vw;
      }
    }

    .helpPic::-webkit-scrollbar {
      display: none
    }

    .desc {
      margin-top: 1.5vw;
      text-align: center;
      font-size: 3.333vw;
      font-weight: 400;
    }

    .video {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 90.277vw;
      height: 40.377vw;
      //display: none;
      .play {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 10.277vw;
        z-index: 2;
      }

      .preview {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        height: 100%;
        filter: brightness(60%);
      }
    }
  }

  .videoPreview {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    width: 100vw;
    height: 100vh;
    padding-top: 56px;
    padding-bottom: 70px;
    background-color: #000000;
    overflow-y: scroll;
    display: flex;
    justify-content: space-between;

    .videoBox {
      margin-left: 12.5vw;
      margin-top: 2vw;
      width: 75vw;
      height: max-content;
      video {
        width: 100%;
        height: auto;
      }
    }

    .close {
      margin-right: 2.75vw;
      margin-top: 2vw;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      width: 7vw;

      img {
        width: 100%;
      }
    }
  }

  .videoPreview::-webkit-scrollbar {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UpiHelpPop/index.vue